import { StyleSheet } from 'react-native';

import { extraSmallPaddingBox } from '../view-style';

export default StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    ...extraSmallPaddingBox,
    borderTopLeftRadius: 10,
  },
});
